/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./airdropFirst.vue?vue&type=template&id=38cc149f&scoped=true"
import script from "./airdropFirst.vue?vue&type=script&lang=js"
export * from "./airdropFirst.vue?vue&type=script&lang=js"
import style1 from "./airdropFirst.vue?vue&type=style&index=1&id=38cc149f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cc149f",
  null
  
)

export default component.exports